export enum DocumentDetailViewTab {
  DOCUMENT = 'document',
  DOCUMENT_HISTORY = 'document-history',
}

export interface IMetadataEntry {
  field: string;
  fieldDisplayName: string;
  value: string | string[];
}
